var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00169 3.77054L1.00878 0.777755C0.926569 0.695348 0.81665 0.650015 0.699447 0.650015C0.582179 0.650015 0.472325 0.695348 0.389984 0.777755L0.12787 1.04C0.0453984 1.12227 3.53573e-08 1.23226 3.43509e-08 1.34946C3.33445e-08 1.46667 0.0453984 1.57652 0.12787 1.65886L3.69119 5.22224C3.77379 5.30491 3.88416 5.35018 4.0015 5.34985C4.11935 5.35018 4.22959 5.30497 4.31226 5.22224L7.87213 1.66218C7.9546 1.57984 8 1.46998 8 1.35271C8 1.23551 7.9546 1.12566 7.87213 1.04325L7.61002 0.781072C7.43941 0.61047 7.16169 0.61047 6.99115 0.781072L4.00169 3.77054Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.d21ab988.svg";
export { ForwardRef as ReactComponent };